import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { AgentClient, AgentsBasicInfoDto } from "../../../app/System-api";
import { NbDialogRef, NbToastrService } from "@nebular/theme";

@Component({
  selector: "simple-agents-modal",
  templateUrl: "./simple-agents-modal.component.html",
  styleUrls: ["./simple-agents-modal.component.scss"],
})
export class SimpleAgentsModalComponent implements OnInit {
  @Input() selectedAgents: AgentsBasicInfoDto[] = [];
  @Output() onSelectAgents = new EventEmitter<AgentsBasicInfoDto[]>();
  @Input() maxMembers: number = 10;

  agents: AgentsBasicInfoDto[] = [];
  isLoading = false;
  searchTerm = '';
  private maxMembersNotificationRef: any;

  constructor(
    private agentClient: AgentClient,
    protected dialogRef: NbDialogRef<SimpleAgentsModalComponent>,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.loadAgents();
  }

  loadAgents() {
    this.isLoading = true;
    this.agentClient.getAgentBasicInfoList().subscribe(
      (response) => {
        this.agents = response.agents;
        this.isLoading = false;
      },
      (error) => {
        console.error('Error loading agents:', error);
        this.isLoading = false;
      }
    );
  }

  isSelected(agent: AgentsBasicInfoDto): boolean {
    return this.selectedAgents.some(a => a.extension === agent.extension);
  }

  toggleSelection(agent: AgentsBasicInfoDto) {
    const index = this.selectedAgents.findIndex(a => a.extension === agent.extension);
    if (index > -1) {
      this.selectedAgents.splice(index, 1);
      if (this.selectedAgents.length < this.maxMembers) {
        this.maxMembersNotificationRef = null;
      }
    } else {
      if (this.selectedAgents.length >= this.maxMembers) {
        if (!this.maxMembersNotificationRef) {
          this.maxMembersNotificationRef = this.toastrService.warning(
            'Maximum 10 members allowed',
            'Warning',
            { duration: 2000, destroyByClick: true }
          );
        }
        return;
      }
      this.selectedAgents.push(agent);
    }
  }

  confirm() {
    this.onSelectAgents.emit(this.selectedAgents);
    this.dialogRef.close();
  }

  cancel() {
    this.dialogRef.close();
  }

  get filteredAgents() {
    return this.agents.filter(agent => 
      agent.extension.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      agent.fullName.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  ngOnDestroy() {
    if (this.maxMembersNotificationRef) {
      this.maxMembersNotificationRef.close();
    }
  }
}